<template lang="pug">
#garage.container-fluid.pt-2(v-cloak)
  .text-center
    h1.fw-bolder Garage
    .p-1
    button-toggler.btn.btn-success(:opened="isOpen", @click.native="toggle") Craft a new chatbot

  .p-2

  transition-expand
    .row(v-if="isOpen", v-cloak)
      .col.p-2(v-for="platform in platforms")
        a.btn.btn-sm.btn-light.border.p-3.h-100.w-100(:href="platform.link")
          img(:src="platform.logo", width="24")
          .d-none.d-sm-block.pt-2 {{ platform.name }}

  loader(v-if="loading")
  template(v-else)
    .row
      .col-6.col-sm-4.col-md-3.col-lg-2.p-2(v-for="chatbot in chatbots")
        t-chatbot(:chatbot="chatbot")

hr(v-if="!loading")
</template>

<script>
import PipeHeader from '@/components/pages/Header'
import Loader from '@/components/base/Loader'
import TChatbot from '@/components/TChatbot'
import ButtonToggler from '@/components/base/ButtonToggler'
import TransitionExpand from '@/components/transition/Expand'

import { getBotsList } from '@/services/api/bot.api'

import { platforms } from '@/utils/constants/platforms'

export default {
  components: {
    PipeHeader,
    ButtonToggler,
    TChatbot,
    TransitionExpand,
    Loader
  },
  data: () => ({
    platforms: Object.values(platforms),
    isOpen: false,
    loading: false,
    chatbots: []
  }),
  async created() {
    await this.prefetchBots()
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen
    },
    async prefetchBots() {
      const clientToken = this.$cookie.get('clientToken')
      let defaultLoadingTimePassed = false
      if (clientToken) {
        this.loading = true
        setTimeout(() => {
          defaultLoadingTimePassed = true
          if (this.chatbots) {
            this.loading = false
          }
        }, 600)
        try {
          const { data } = await getBotsList({ clientToken })
          this.chatbots = data
          if (defaultLoadingTimePassed && this.loading) {
            this.loading = false
          }
        } catch (err) {
          console.log('Bots fetch error: ' + err)
        }
      } else {
        window.location.replace('/')
      }
    }
  }
}
</script>

<style lang="sass" scoped>
[v-cloak]
  display: none

.zoom
  transition: transform 0.125s ease-out
  &:hover
    transform: scale(1.025)

.card
  transition: transform $duration $timing-function
  &:hover
    transform: scale(1.0725)
    .card-footer
      opacity: 1

.pipe-navbar .navbar-nav-scroll
  max-width: 100%
  height: 2.4rem
  overflow: hidden

@media (max-width: 991.98px)
  .pipe-navbar .navbar-nav-scroll .navbar-nav
    padding-bottom: 2rem
    overflow-x: auto
    white-space: nowrap
    -webkit-overflow-scrolling: touch

@media (min-width: 768px)
  @supports (position: -webkit-sticky) or (position: sticky)
    .pipe-navbar
      position: -webkit-sticky
      position: sticky
      top: 0
      z-index: 1040

@media (max-width: 576px)
  .navbar-nav-scroll
    overflow-x: auto
    white-space: nowrap
    overflow: hidden
    font-size: .875rem
    -webkit-overflow-scrolling: touch
    -webkit-box-orient: horizontal
    -webkit-box-direction: normal
  .nav-pills
    font-size: .875rem

@media (min-width: 991.98px)
  .card-columns
    column-count: 6
    &.docs
      column-count: 4

*
  will-change: height
  transform: translateZ(0)
  backface-visibility: hidden
  perspective: 1000px

.expand-enter-active, .expand-leave-active
  transition: height $duration ease-in-out
  overflow: hidden
  transition-property: opacity, height, transform

.expand-enter, .expand-leave-to
  height: 0
  opacity: 0
</style>
